import Asset from '../model/asset';

export class FileHelper {
  public static isImage(a: Asset): boolean {
    return a?.type === 'image/png' || a?.type === 'image/jpeg';
  }

  public static isPdf(a: Asset): boolean {
    return a?.type === 'application/pdf';
  }
}
